import { Route, useNavigate } from 'react-router-dom';
import { LoginCallback, Security } from '@okta/okta-react';
import { ApmRoutes } from '@elastic/apm-rum-react';
import React from 'react';
import { OktaAuth, toRelativeUrl } from '@okta/okta-auth-js';
import { OktaLogin } from './views/Pages/OktaLogin/OktaLogin';
import DefaultLayout from './containers/DefaultLayout';
import SequenceEditorRoute from './views/Sequences/SequenceEditorRoute';
import OfferBlockEditorRoute from './views/OfferBlocks/OfferBlockEditorRoute';
import ProtectedRoute from './components/ProtectedRoute/ProtectedRoute';
import { cfg } from './runtime-config';

const oktaAuth = new OktaAuth({
  issuer: cfg('OKTA_ISSUER') || 'https://whatifmediagroup.okta.com/oauth2/default',
  clientId: cfg('OKTA_CLIENT_ID'),
  redirectUri: window.location.origin + '/login/callback',
  tokenManager: {
    autoRenew: true,
  },
});

const OktaApp = () => {
  const navigate = useNavigate();

  const restoreOriginalUri = async (_oktaAuth, originalUri) => {
    if (window.location.pathname.includes('/login') || window.location.pathname.includes('/login/callback')) {
      const preLoginUrl = sessionStorage.getItem('preLoginUrl');
      sessionStorage.removeItem('preLoginUrl');
      navigate(toRelativeUrl(preLoginUrl || originalUri || '/', window.location.origin));
    }
  };

  return (
    <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
      <ApmRoutes>
        <Route
          path='/campaigns/sequences/create'
          element={
            <ProtectedRoute>
              <SequenceEditorRoute />
            </ProtectedRoute>
          }
        />
        <Route
          path='/campaigns/sequences/:sequenceId'
          element={
            <ProtectedRoute>
              <SequenceEditorRoute />
            </ProtectedRoute>
          }
        />
        <Route
          path='/campaigns/offerblocks/:offerBlockId'
          element={
            <ProtectedRoute>
              <OfferBlockEditorRoute />
            </ProtectedRoute>
          }
        />
        <Route path='/login' element={<OktaLogin />} />
        <Route path='/login/callback' element={<LoginCallback />} />
        <Route
          path='/*'
          element={
            <ProtectedRoute>
              <DefaultLayout />
            </ProtectedRoute>
          }
        />
      </ApmRoutes>
    </Security>
  );
};

export default OktaApp;
